import { RootState } from './store'

export const customTheme = (state: RootState) => state.customization
export const authStore = (state: RootState) => state.auth
